import { styled, LockIcon } from 'canoe';
import React from 'react';

const Text = ({ children, leaf }: any) => {
  let result = children;

  if (leaf.bold) {
    result = <strong>{result}</strong>;
  }

  if (leaf.code) {
    result = <code>{result}</code>;
  }

  if (leaf.italic) {
    result = <em>{result}</em>;
  }

  if (leaf.underline) {
    result = <u>{result}</u>;
  }

  return <span>{result}</span>;
};

const StyledContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const TextWrapper = styled.div`
  opacity: 0.5;
`;

const HiddenText = styled.div`
  display: none;
`;

interface CollectionNodeProps {
  children: React.ReactNode;
  collectionText: string;
  leaf: any;
}

export const CollectionNode: React.FC<CollectionNodeProps> = ({
  collectionText,
  leaf,
  children,
}: CollectionNodeProps) => {
  return (
    <StyledContainer>
      <LockIcon color="MangoOrangeD10" />
      <TextWrapper>
        <Text leaf={leaf}>{collectionText}</Text>
      </TextWrapper>
      <HiddenText>{children}</HiddenText>
    </StyledContainer>
  );
};
